module.exports = __webpack_public_path__ + "img/lingyu4.3396a4a6.webp";